import React, { useEffect, useState } from "react";
import { AppBar, Box, Container, Fade, useMediaQuery } from "@mui/material";
import MobileMenu from "../menus/MobileMenu";
import Logo from "../images/logo.png";
import Menu from "../menus/Menu";
import { useNavigate } from "react-router-dom";
import SearchButton from "../search/SearchButton";

const Header = () => {
  const mdDown = useMediaQuery((theme) => theme.breakpoints.down("md"));
  const [menu, setMenu] = useState();
  const navigate = useNavigate();
  const [searchClicked, setSearchClicked] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);

  //Prevent scrolling on the body when menu or search are open
  useEffect(() => {
    if (searchClicked || drawerOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "visible";
    }
  }, [searchClicked, drawerOpen]);

  return (
    <AppBar
      position="sticky"
      sx={{
        //top: scrollDirection === "down" ? mdDown ? "-100px" : "-120px" : "0",
        zIndex: "1400",
        height: "100px",
        transition: "top 0.3s ease-in-out",
        backgroundColor: (theme) => theme.palette.header.main,
        ".admin-bar &": {
          top: "32px",
        },
      }}
    >
      <Container
        maxWidth="xl"
        sx={{
          margin: "auto",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          //maxWidth: `calc(${theme.width.maxwidth} + 8%)!important`,
          //padding: '0 4%!important',
        }}
      >
        {/* <Widget widget="header" /> */}
        <Box
          sx={{
            width: "80px",
            height: "80px",
          }}
        >
          <Fade in={menu ? true : false}>
            <img
              src={Logo}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
              }}
              onClick={() => {
                //home page
                navigate("/");
              }}
            />
          </Fade>
        </Box>
        {!mdDown && (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <Menu
              setMenu={setMenu}
              menu={menu}
              searchClicked={searchClicked}
              setSearchClicked={setSearchClicked}
            />
          </Box>
        )}
        {mdDown && (
          <Fade in={Boolean(menu)}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <SearchButton
                searchClicked={searchClicked}
                onClick={() => {
                  setSearchClicked(!searchClicked);
                  setDrawerOpen(false);
                }}
              />
              <MobileMenu
                setMenu={setMenu}
                menu={menu}
                drawerOpen={drawerOpen}
                setDrawerOpen={setDrawerOpen}
                setSearchClicked={setSearchClicked}
              />
            </Box>
          </Fade>
        )}
      </Container>
    </AppBar>
  );
};

export default Header;
